// =============================================================================
// Konfiguration - woher die Anwendung ihre Adressen und Werte nimmt
// =============================================================================
//
// Zwei Quellen, in dieser Reihenfolge:
//
//   1. window.__ASSISTENT_KONFIG__  aus /konfiguration.js. Diese Datei liegt
//      NEBEN dem Build und wird auf dem Server beim Containerstart aus der
//      .env erzeugt. Ein Domainwechsel ist damit ein Neustart, kein Neubau -
//      so verspricht es der Architekturabschnitt im README.
//
//   2. import.meta.env.VITE_*  aus .env.local. Das ist der Weg fuer
//      "npm run dev" auf dem Entwicklungsrechner.
//
// Nichts davon ist im Code hartkodiert. Fehlt die Directus-Adresse in BEIDEN
// Quellen, startet die Anwendung nicht mit einem geratenen Standardwert,
// sondern sagt klar, was fehlt - ein falscher Standardwert wuerde nur zu
// "keine Verbindung" fuehren und die eigentliche Ursache verstecken.
// =============================================================================

interface LaufzeitKonfig {
  directusUrl?: string;
  schuljahrStart?: string;
}

declare global {
  interface Window {
    __ASSISTENT_KONFIG__?: LaufzeitKonfig;
  }
}

/** Leere Zeichenketten gelten als "nicht gesetzt". Der Platzhalter in
 *  public/konfiguration.js besteht genau daraus und soll die Entwicklung
 *  nicht stoeren. */
function ersterWert(...kandidaten: (string | undefined)[]): string {
  for (const k of kandidaten) {
    if (typeof k === 'string' && k.trim() !== '') return k.trim();
  }
  return '';
}

const laufzeit: LaufzeitKonfig = window.__ASSISTENT_KONFIG__ ?? {};

/** Basisadresse von Directus, ohne Schraegstrich am Ende. */
export const DIRECTUS_URL: string = ersterWert(
  laufzeit.directusUrl,
  import.meta.env.VITE_DIRECTUS_URL,
).replace(/\/+$/, '');

/** Beginn des Schuljahres als JJJJ-MM-TT, fuer die Schulwochenzaehlung.
 *  Fehlt der Wert, blendet die Kopfzeile die Schulwoche aus, statt eine
 *  falsche Zahl zu zeigen. */
export const SCHULJAHR_START: string = ersterWert(
  laufzeit.schuljahrStart,
  import.meta.env.VITE_SCHULJAHR_START,
);

/** Sagt, ob die Anwendung ueberhaupt arbeiten kann. Wird beim Start geprueft. */
export function konfigurationFehlt(): string | null {
  if (DIRECTUS_URL === '') {
    return 'Die Adresse von Directus ist nicht konfiguriert.';
  }
  return null;
}
